import Svg from '@rexlabs/icons/arrow-down-filled.svg';
export default Svg;
